( function() {
    "use strict";

    angular
        .module('ccsTrApp')
        .service('LocationCustomService', LocationCustomService);

    LocationCustomService.$inject = ['$http'];

    function LocationCustomService( $http ) {
        var service = {
            returnLocationsByCompany: returnLocationsByCompany,
            returnLocation: returnLocation
        }

        return service;

        function returnLocationsByCompany( id ) {
            var url = "api/locations/company/" + id;
            return $http.get( url );
        }

        function returnLocation( id, location ) {
            var url = "api/location?id=" + id + "&name=" + location;
            return $http.get( url );
        }
    }

})();
